export default __webpack_public_path__ + "static/media/kingofkings-logo.a9748692.png";